// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__382wr","detailsBorder":"styles_detailsBorder__3uYSa"};